import { render, staticRenderFns } from "./CostPricesAdditionalFees.vue?vue&type=template&id=77917996"
import script from "./CostPricesAdditionalFees.vue?vue&type=script&lang=js"
export * from "./CostPricesAdditionalFees.vue?vue&type=script&lang=js"
import style0 from "./CostPricesAdditionalFees.vue?vue&type=style&index=0&id=77917996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports